import Api from '@/services/api';
import {useZoneStore} from '@store/zoneStore';

export default {
  zones() {
    return Api()
      .get('/zones')
      .then((res) => {
        return res.data;
      });
  },
  zoneStorage() {
    let store = useZoneStore();
    return store.all();
  },
};
